import { lazy } from "react";

export const AboutUsAsync = lazy(()=> import('./AboutUs'))
